import { formatDate } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { catchError, of, take } from 'rxjs';
import { httpOptions } from 'src/app/global/global_variables';
import { DocksModel } from 'src/app/models/DocksModel';
import { TrucksExpModel } from '../../models/TrucksExpModel';
import { TimeTableModel } from '../../models/TimeTableModel';
import { ExpeditionService } from 'src/app/services/expedition/expedition.service';
import { ExpeditionResponse } from 'src/app/models/ExpeditionResponse';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { TripResponse } from 'src/app/models/TripResponse';

@Component({
  selector: 'app-lcb-expedicao',
  templateUrl: './lcb-expedicao.component.html',
  styleUrls: ['./lcb-expedicao.component.css'],
})
export class LCBExpedicaoComponent {
  // UI controls
  @Output() refresh = new EventEmitter();
  status: boolean = true;
  toggle: boolean = false;

  // Data
  expeditionTripsData: ExpeditionResponse[] = [];
  expeditionDocks: DocksModel[] = [];
  expeditionData: TrucksExpModel[] = []
  timeTableData: TimeTableModel[] = [];
  selectedDock: DocksModel | any;
  Date = Date.now();

  // variables
  dateInterval: any;
  saidaReal: any;
  updateInterval: any;
  apiLink = environment.apiLink;
  httpOptions = httpOptions;
  takt: string = '';

  public dock: number = 0;
  public dockId: number = 0;
  public bgColor: string = 'white';
  public statusDock: string = 'white';
  public ftColor: string = '';
  public trip: any;

  nextTrip: any
  activeTrip: any;

  constructor(
    private expService: ExpeditionService,
    private router: Router,
    private route: ActivatedRoute) { }


  ngOnInit() {
    this.updateData();
    this.dateInterval = setInterval(() => {
      this.Date = Date.now();
      this.timer();
    }, 5000);
    this.updateInterval = setInterval(() => {
      this.updateData();
    }, 5000);
  }

  updateData(): void {
    this.expService.getTimeTableData().pipe
      (take(1),
        catchError(() => {
          return of([])
        })
      ).subscribe(
        (data: TimeTableModel[]) => {
          this.timeTableData = data
        }
      )

    this.expService.getExpeditionTableData().pipe
      (take(1),
        catchError(() => {
          return of({ trucks: [], docks: [] })
        })
      ).subscribe(
        (response) => {
          this.expeditionData = response.trucks
          this.expeditionDocks = response.docks.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
    if (this.selectedDock && this.expeditionDocks.some(d => d.id === this.selectedDock.id)) {
      this.selectedDock = this.expeditionDocks.find(d => d.id === this.selectedDock.id);
    }
  }

  updateTripInfo(activeTrip: TripResponse, selectedDock: any) {

    const agora = new Date();
    const [hora, minuto] = activeTrip.saidaLCB.split(':');
    const horaPrevista = new Date();
    const dataReal = new Date(selectedDock.status);
    const dataPrevista = new Date();

    horaPrevista.setHours(Number(hora), Number(minuto), 0, 0);
    dataPrevista.setHours(Number(activeTrip.inicioLCB.split(':')[0]));
    dataPrevista.setMinutes(Number(activeTrip.inicioLCB.split(':')[1]));
    dataPrevista.setSeconds(60);

    let diferencaTempo = horaPrevista.getTime() - agora.getTime();
    let minutos = Math.floor(diferencaTempo / (1000 * 60));
    let segundos = Math.floor((diferencaTempo % (1000 * 60)) / 1000);
    let segundosString = this.formatarNumero(segundos.toString().replace('-', ''));

    const box_inicio_top = document.querySelector('.box-start-card-top') as HTMLElement;
    const box_inicio_bottom = document.querySelector('.box-start-card-bottom') as HTMLElement;
    const box_fim_top = document.querySelector('.box-finish-card-top') as HTMLElement;
    const box_fim_bottom = document.querySelector('.box-finish-card-bottom') as HTMLElement;

    // Ajusta minutos se forem negativos
    if (minutos < 0) minutos += 1;

    // Atualiza a cor das caixas de início
    if (dataReal > dataPrevista) {
      box_inicio_top.style.backgroundColor = '#FF2340';
      box_inicio_bottom.style.backgroundColor = '#FF2340';
    } else {
      box_inicio_top.style.backgroundColor = '#3CB371';
      box_inicio_bottom.style.backgroundColor = '#3CB371';
    }

    // Atualiza a cor das caixas de fim
    if (minutos < 0 || segundos < 0) {
      box_fim_top.style.backgroundColor = '#FF2340';
      box_fim_bottom.style.backgroundColor = '#FF2340';
    } else {
      box_fim_top.style.backgroundColor = '#3CB371';
      box_fim_bottom.style.backgroundColor = '#3CB371';
    }

    const resultado = this.converterMinutosParaHoras(minutos);
    minutos = resultado?.minutos;
    const horas = resultado?.horas;

    const minutosString = this.formatarNumero(minutos.toString().replace('-', ''));
    const horasString = this.formatarNumero(horas.toString().replace('-', ''));

    // Atualiza a saída real
    if (minutos < 0 || segundos < 0) {
      this.saidaReal = '-' + horasString + ':' + minutosString + ':' + segundosString;
    } else {
      this.saidaReal = horasString + ':' + minutosString + ':' + segundosString;
    }
  }

  timer() {
    if (!this.selectedDock) return
    if (this.shouldUpdateDockInfoToActiveTrip()) {
      this.updateDockInfoToActiveTrip();

      this.updateTripInfo(this.activeTrip, this.selectedDock)
    } else if (this.shouldUpdateDockInfoToGetNextTrip()) {
      this.getNextTripInQueue(this.dockId);
      this.activeTrip = null
    }
  }

  shouldUpdateDockInfoToActiveTrip(): boolean {
    return this.selectedDock.truck == 1 && this.selectedDock.active == 1;
  }

  shouldUpdateDockInfoToGetNextTrip(): boolean {
    return this.selectedDock.truck == 0 && this.selectedDock.active == 1;
  }

  updateDockInfoToActiveTrip() {
    if (this.activeTrip) {

      const hasExtraTrip = this.isExtraTrip(this.activeTrip)
      if (!hasExtraTrip) {
        const statusTime = this.convertTimeStringToMs(this.formatTimeSensor(this.selectedDock?.status));
        const currentTime = this.convertTimeStringToMs(this.formatTimeFromTimestamp(Date.now()));
        const inicioLCB = this.activeTrip.inicioLCB;
        const saidaLCB = this.activeTrip.saidaLCB;

        const inicioLCBTime = this.convertTimeStringToMs(inicioLCB);
        const saidaLCBTime = this.convertTimeStringToMs(saidaLCB);
        const taktTime = this.convertTimeStringToMs(this.calculateDifference(inicioLCB, saidaLCB));

        const delta = this.calculateDelta(inicioLCBTime, saidaLCBTime, statusTime, currentTime, taktTime);
        this.updateTaktDisplay(delta, taktTime);
      } else {
        const statusTime = this.convertTimeStringToMs(this.formatTimeSensor(this.selectedDock?.status));
        const currentTime = this.convertTimeStringToMs(this.formatTimeFromTimestamp(Date.now()));
        const extraTime = this.convertTimeStringToMs(this.activeTrip.extra)

        this.updateTaktDisplay((extraTime + statusTime - currentTime), extraTime)
      }
    } else {
      this.getActiveTrip(this.dockId)
      this.getNextTripInQueue(this.dockId)
      return
    }
  }

  isExtraTrip(trip: any) {
    if (trip.extra == null || trip.extra == undefined)
      return false
    else return true
  }

  calculateDelta(inicioLCBTime: number,
    saidaLCBTime: number,
    statusTime: number,
    currentTime: number,
    taktTime: number
  ): number {
    return taktTime + statusTime - currentTime
  }

  updateTaktDisplay(delta: number, taktTime: number) {
    this.takt = formatDate(Math.abs(delta), 'HH:mm:ss', 'en-US', 'UTC');

    if (delta < 0) {
      this.bgColor = '#FF2340';
      this.takt = '-' + this.takt;
    } else if (delta < taktTime / 3) {
      this.bgColor = '#F1C21B';
    } else {
      this.bgColor = '#3CB371';
    }
  }

  changeDock(docks: number): void {

    this.selectedDock = this.expeditionDocks.find((d) => d.id == docks);
    this.dock = this.selectedDock.description;
    this.dockId = this.selectedDock.id;

    this.refreshQueue();
  }

  //* -------------------------------------------- FILA DE VIAGENS -------------------------------------------- *//
  getActiveTrip(dockId: number): void {
    this.expService.getActiveTrip(dockId).subscribe(
      filteredTrip => { this.activeTrip = filteredTrip.tripsInQueue.length > 0 ? filteredTrip.tripsInQueue[0] : null }
    )
  }

  getNextTripInQueue(dockId: number): void {

    this.expService.getNextTripInQueue(dockId).subscribe(
      response => {
        if (response.tripsInQueue.length > 0) {
          console.log("Encontrou próxima viagem: ", response);
          this.nextTrip = response.tripsInQueue[0];
          this.bgColor = "#fff";
        } else {
          console.log("Atribuindo null: ", response);
          this.nextTrip = null;
          this.bgColor = "#fff";
        }
      },
      error => {
        console.error('Erro ao buscar a próxima viagem na fila:', error);
        this.nextTrip = null;
      }
    );
  }

  refreshQueue(): void {
    this.getActiveTrip(this.dockId);
    this.getNextTripInQueue(this.dockId);
  }


  //* -------------------------------------------- FORMATAÇÃO DE NÚMEROS -------------------------------------------- *//
  calculateDifference(start: string, end: string): string {

    const endTime = this.convertTimeStringToValidDate(end);
    const startTime = this.convertTimeStringToValidDate(start);

    if (!startTime || !endTime) return " "

    if (endTime.getTime() < startTime.getTime()) {
      // Adiciona 24 horas ao endTime se ele for menor que startTime
      endTime.setDate(endTime.getDate() + 1);
    }

    const diffInMs = endTime.getTime() - startTime.getTime();

    const diffInHours = Math.floor(diffInMs / (60 * 60 * 1000));
    const diffInMinutes = Math.floor((diffInMs % (60 * 60 * 1000)) / (60 * 1000));
    const diffInSeconds = Math.floor((diffInMs % (60 * 1000)) / 1000);

    const formattedHours = String(diffInHours).padStart(2, '0');
    const formattedMinutes = String(diffInMinutes).padStart(2, '0');
    const formattedSeconds = String(diffInSeconds).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  calculateDifferenceInMinutes(statusTime: string, currentTime: string): number {
    // Realiza o split para obter horas, minutos e segundos (se disponíveis)
    const [statusHours, statusMinutes] = statusTime.split(':').map(Number);
    const [currentHours, currentMinutes, currentSeconds] = currentTime.split(':').map(Number);

    // Converte os dois horários para minutos totais
    const statusTotalMinutes = statusHours * 60 + statusMinutes;
    const currentTotalMinutes = currentHours * 60 + currentMinutes + (currentSeconds ? currentSeconds / 60 : 0);

    // Se o horário atual for menor que o statusTime, significa que houve uma virada de dia
    if (currentTotalMinutes < statusTotalMinutes) {
      // Adiciona 24 horas (1440 minutos) ao currentTotalMinutes para contabilizar a virada do dia
      return Math.floor((currentTotalMinutes + 1440) - statusTotalMinutes);
    } else {
      // Calcula a diferença normalmente se não houver virada de dia
      return Math.floor(currentTotalMinutes - statusTotalMinutes);
    }
  }

  convertTimeStringToValidDate(timeString: string): Date | null {
    if (!timeString) return null;

    const currentDate = new Date();
    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    currentDate.setHours(hours);
    currentDate.setMinutes(minutes);
    currentDate.setSeconds(seconds || 0);
    currentDate.setMilliseconds(0);

    return currentDate;
  }

  convertTimeStringToMs(timeString: string): number {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return ((hours * 60 + minutes) * 60 + (seconds || 0)) * 1000;
  }

  convertMsToTimeString(ms: number): string {
    let totalMinutes = Math.floor(ms / (1000 * 60));
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;

    let formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return formattedTime;
  }

  formatTimeSensor(sensorTime: string): string {
    return new Date(sensorTime).toLocaleDateString('pt-BR', { hour: '2-digit', minute: '2-digit' }).substring(12);
  }

  formatTimeFromTimestamp(timestamp: number): string {
    let date = new Date(timestamp);

    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();

    let formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    return formattedTime;
  }

  converterMinutosParaHoras(minutos: number) {
    const sinal = Math.sign(minutos); // Obtém o sinal dos minutos (1 para positivo, -1 para negativo, 0 para zero)

    // Converte para valor absoluto e realiza a conversão para horas e minutos
    const minutosAbs = Math.abs(minutos);
    const horas = Math.floor(minutosAbs / 60);
    const minutosRestantes = minutosAbs % 60;

    return {
      horas: sinal * horas,
      minutos: minutosRestantes,
    };
  }

  formatarNumero(numero: string) {
    return Number(numero) < 10 ? `0${numero}` : numero;
  }


  //função sem uso temporariamente
  formatarData(dockTimeStamp: any) {

    // Obter os componentes da data no horário UTC
    const year = dockTimeStamp.getUTCFullYear();
    const month = String(dockTimeStamp.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth retorna de 0 a 11
    const day = String(dockTimeStamp.getUTCDate()).padStart(2, '0');
    const hours = String(dockTimeStamp.getUTCHours()).padStart(2, '0');
    const minutes = String(dockTimeStamp.getUTCMinutes()).padStart(2, '0');
    const seconds = String(dockTimeStamp.getUTCSeconds()).padStart(2, '0');

    // Montar a data no formato desejado
    const reformattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    return reformattedDate
  }

  //* ---------------------- BOTÕES DOCAS ---------------------- *//

  public statusDocks(docks: number): string {
    let st: any = this.expeditionDocks.find((t) => t.id == docks);
    let x: string = 'white';

    if (st && st.truck !== undefined && st.status) {
      if (st.truck == 1) {
        x = '#3CB371';
      } else {
        if (st.status.getTime() > this.Date - 300000) {
          x = 'white';
        } else {
          x = '#FF2340';
        }
      }
    }

    return x;
  }


  navigate(page: string) {
    this.router.navigate([page], { relativeTo: this.route });
  }

  openTimeTable() {
    this.toggle = !this.toggle;
  }

  onToggleChange(newToggleValue: boolean) {
    this.toggle = newToggleValue;
  }

}

